import { MainMenuItemsList } from 'app/navbar/MenuConfig';

export const contentMenuItems: MainMenuItemsList = [
    {
        label: 'content.elements',
        key: 'content_elements',
        href: '/editor',
        icon: { type: 'mi', value: 'elements' },
        searchData: {
            keywords: {
                entity: ['element', 'metric', 'report', 'external_report', 'external_content'],
            },
        },
    },
    {
        label: 'content.datasets',
        key: 'content_datasets',
        href: '/editor/dataset',
        icon: { type: 'mi', value: 'datasets' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_DATASET' }],
        searchData: {
            keywords: {
                entity: ['dataset'],
            },
        },
    },
    {
        label: 'content.user_maps',
        key: 'content_user_maps',
        href: '/editor/dataset-access-map',
        icon: { type: 'mi', value: 'user-maps' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_DATASET' }],
        searchData: {
            keywords: {
                entity: ['user_map'],
            },
        },
    },
    {
        label: 'content.dimensions',
        key: 'content_dimensions',
        href: '/editor/segment',
        icon: { type: 'mi', value: 'dimension' },
        searchData: {
            keywords: {
                entity: ['dimension'],
                entityAlias: ['segment'],
            },
        },
    },
    {
        label: 'content.content_center',
        key: 'content_content_center',
        href: '/admin/engagement',
        icon: { type: 'mi', value: 'content-center' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_USE_CONTENT_CENTER' }],
        searchData: {
            keywords: {
                manuLabel: true,
            },
            labelSuffix: 'none',
        },
    },
    {
        divider: true,
    },
    {
        label: 'content.portal_pages',
        key: 'content_portal_pages',
        href: '/editor/page',
        icon: { type: 'mi', value: 'portal-pages' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_PORTAL_PAGES' }],
        searchData: {
            desc: 'app',
            keywords: {
                entity: ['app'],
                entityAlias: ['portal_page'],
            },
        },
    },
    {
        label: 'content.catalogs',
        key: 'content_catalogs',
        href: '/editor/catalog',
        icon: { type: 'mi', value: 'list-items' },
        condition: [{ type: 'isAdmin' }],
        searchData: {
            desc: 'catalog',
            keywords: {
                entity: ['catalog'],
            },
        },
    },
    {
        divider: true,
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_PORTAL_PAGES' }],
    },
    {
        label: 'notification.folders',
        key: 'content_folders',
        href: '/notification/folder',
        icon: { type: 'mi', value: 'folders' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_ADD_FOLDERS' }],
        searchData: {
            keywords: {
                entity: ['folder', 'category'],
            },
        },
    },
    {
        label: 'notification.favorites',
        key: 'content_favorites',
        href: '/notification/favorite',
        icon: { type: 'mi', value: 'favorite-solid' },
        condition: [{ type: 'isAdmin' }],
        searchData: {
            desc: 'favorite',
            keywords: {
                entity: ['favorite', 'category'],
            },
        },
    },
    {
        label: 'content.categories',
        key: 'content_categories',
        href: '/editor/category',
        icon: { type: 'mi', value: 'categories' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_CATEGORIES' }],
        searchData: {
            desc: 'category',
            keywords: {
                entity: ['category'],
            },
        },
    },
    {
        label: 'content.glossary',
        key: 'content_glossary',
        href: '/editor/glossary',
        icon: { type: 'mi', value: 'glossary' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_GOVERNED_TAGS' }],
        searchData: {
            keywords: {
                entity: ['glossary_term'],
            },
        },
    },
    {
        label: 'content.measure_conflicts',
        key: 'content_measure_conflicts',
        href: '/editor/measure-conflicts',
        icon: { type: 'mi', value: 'measure-inconsistencies' },
        condition: [{ type: 'conciergeEnabled' }, { type: 'adminOrPrivilege', params: 'PRIV_MANAGE_KNOWLEDGE_GRAPH' }],
        searchData: {
            keywords: {
                entity: ['measure_conflict'],
            },
        },
    },
    {
        label: 'content.tags',
        key: 'content_tags',
        href: '/editor/topic',
        icon: { type: 'mi', value: 'tags' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_TAGS' }],
        searchData: {
            keywords: {
                entity: ['topic', 'category'],
                entityAlias: ['topic'],
            },
        },
    },
    {
        label: 'admin.custom_field',
        key: 'admin_custom_field',
        href: '/editor/custom-field',
        icon: { type: 'mi', value: 'custom-field' },
        condition: [{ type: 'isAdmin' }],
        searchData: {
            keywords: {
                entity: ['custom_field'],
            },
        },
    },
    {
        label: 'content.content_workflows',
        key: 'content_content_workflows',
        href: '/editor/content-workflow',
        icon: { type: 'mi', value: 'publishing-workflows' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_CONTENT_WORKFLOWS' }],
        searchData: {
            keywords: {
                entity: ['publishing_workflow'],
            },
            labelSuffix: 'none',
        },
    },
    {
        divider: true,
    },
    {
        label: 'content.documents',
        key: 'content_documents',
        href: '/editor/document',
        icon: { type: 'mi', value: 'documents' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_DOCUMENTS' }],
        searchData: {
            desc: 'document',
            keywords: {
                entity: ['document'],
            },
        },
    },
    {
        label: 'content.feedback_prompts',
        key: 'content_feedback_prompts',
        href: '/admin/rating-prompt',
        icon: { type: 'mi', value: 'thumbs-up' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_RATING_PROMPTS' }],
        searchData: {
            keywords: {
                entity: ['rating_prompt'],
            },
        },
    },
    {
        label: 'content.announcements',
        key: 'content_announcements',
        href: '/editor/announcement',
        icon: { type: 'mi', value: 'announcements' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_EDIT_ANNOUNCEMENTS' }],
        searchData: {
            desc: 'announcement',
            keywords: {
                entity: ['announcement'],
            },
        },
    },
    {
        divider: true,
        condition: [
            {
                type: 'atLeastOneCondition',
                params: [
                    { type: 'adminOrPrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' },
                    { type: 'adminOrPrivilege', params: 'PRIV_CREATE_ALERT_RULE' },
                ],
            },
        ],
    },

    {
        label: 'content.burst',
        key: 'content_burst',
        href: '/notification/burst',
        icon: { type: 'mi', value: 'burst' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' }],
        searchData: {
            keywords: {
                entity: ['burst'],
            },
        },
    },
    {
        //ToDo: fix console Error link inside link
        label: 'content.alerts',
        key: 'content_alerts',
        // href: '/editor/recent-alerts',
        href: '/editor/kpi-alert-rule',
        icon: { type: 'mi', value: 'alert' },
        condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_ALERT_RULE' }],
        children: [
            {
                label: 'content.user_alerts',
                key: 'content_user_alerts',
                href: '/editor/user-alerts',
                icon: { type: 'mi', value: 'alerts-by-user' },
                searchData: {
                    desc: 'user_alerts',
                    keywords: {
                        manuLabel: true,
                    },
                    labelSuffix: 'none',
                    groupKey: 'alerts',
                },
            },
            {
                label: 'content.kpi_alerts',
                key: 'content_kpi_alerts',
                href: '/editor/kpi-alert-rule',
                icon: { type: 'mi', value: 'alert' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'alerts',
                },
            },
        ],
    },
    {
        divider: true,
        condition: [{ type: 'isAdmin' }],
    },
    {
        label: 'content.trash',
        key: 'content_trash',
        href: '/admin/trash',
        icon: { type: 'mi', value: 'trash' },
        condition: [{ type: 'isAdmin' }],
        searchData: {
            keywords: {
                manuLabel: true,
            },
        },
    },
];
export const contentMenuItemsRegular: MainMenuItemsList = [
    {
        label: 'content.burst',
        key: 'content_burst',
        href: '/notification/burst',
        icon: { type: 'mi', value: 'burst' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' }],
    },
    {
        //ToDo: fix console Error link inside link
        label: 'content.alerts',
        key: 'content_alerts',
        // href: '/editor/recent-alerts',
        href: '/editor/kpi-alert-rule',
        icon: { type: 'mi', value: 'alert' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_ALERT_RULE' }],
        children: [
            {
                label: 'content.user_alerts',
                key: 'content_user_alerts',
                href: '/editor/user-alerts',
                icon: { type: 'mi', value: 'alerts-by-user' },
            },
            {
                label: 'content.kpi_alerts',
                key: 'content_kpi_alerts',
                href: '/editor/kpi-alert-rule',
                icon: { type: 'mi', value: 'alert' },
            },
        ],
    },
    {
        label: 'notification.folders',
        key: 'content_folders',
        href: '/notification/folder',
        icon: { type: 'mi', value: 'folders' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_ADD_FOLDERS' }],
    },
    {
        label: 'content.views',
        key: 'content_views',
        href: '/editor/dataset-filter',
        icon: { type: 'mi', value: 'dataset-view' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_DISPLAY_VIEWS_MENU' }],
    },
    {
        label: 'admin.ns',
        key: 'content_ns',
        href: '/editor/schedule',
        icon: { type: 'mi', value: 'notification-schedule' },
    },
    {
        label: 'admin.ftp',
        key: 'content_ftp',
        href: '/editor/ftp',
        icon: { type: 'mi', value: 'ftp-connection' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_FTP_CONNECTION' }],
    },
    {
        label: 'content.documents',
        key: 'content_documents',
        href: '/editor/document',
        icon: { type: 'mi', value: 'documents' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_DOCUMENTS' }],
    },
];
